import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Empty_FeildActivity_Interface, FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { FeildActivityService } from 'src/app/Service/FeildActivity/FeildActivity.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-FieldActivityEdit',
  templateUrl: './FieldActivityEdit.component.html',
  styleUrls: ['./FieldActivityEdit.component.scss']
})
export class FieldActivityEditComponent implements OnInit {
  EditRecord:Number

  constructor(
    private FeildActivity_Service:FeildActivityService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private route: ActivatedRoute
  ) { }
  ngOnInit() {
    this.EditFeildActivity=new FormGroup({
      id :new FormControl(),

      Title:new FormControl(null,Validators.required),
    })

    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))


    this.Nav_Service.CheckValidPage(17).subscribe(
      data=>{
        this.FeildActivity_Service.GetSingle(this.EditRecord).subscribe(
          data=>{
            this.get_Form_Id().setValue(data.id)

            this.get_Form_Title().setValue(data.title)

          }
        )
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

  }

    //#region  Form Add

    EditFeildActivity:FormGroup;

    get_Form_Id(){
      return this.EditFeildActivity.get('id') as FormControl;
    }


    get_Form_Title(){
      return this.EditFeildActivity.get('Title') as FormControl;
    }

    //#endregion

    InProccessing:boolean=false

    SubmitEditFeildActivity(){
      var Record:FeildActivity_Interface =Empty_FeildActivity_Interface()
      Record.id=this.get_Form_Id().value
      Record.code=""
      Record.title=this.get_Form_Title().value
      this.InProccessing=true
      this.FeildActivity_Service.EditFeildActivity(Record).subscribe(
        data=>{
          this.InProccessing=false
          if(data.id==-1){
            this.Alertify_Service.ErrorMessage("کد وارد شده ، در لیست وجود دارد")
          }
          else if(data.id==-2){
            this.Alertify_Service.ErrorMessage("زمینه فعالیت وارد شده ، در لیست وجود دارد")
          }
          else{

            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          }
        }
      )
    }


}
